module.exports = __webpack_public_path__ + "static/media/phonics_01.848e1249.jpg";